/**
 * marker 与正文之间的间距系数，单位相对当前字号。
 */
export const MARKER_GAP_EM = 0.3;

/**
 * 字符类型列表符号字典。
 */
export const LIST_MARKER_DICT = {
    'lower-latin': 'abcdefghijklmnopqrstuvwxyz',
    'upper-roman': 'ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ',
    decimal: '1234567890',
    disc: '●',
    circle: '○',
    square: '■',
};
